import PageLoading from '@/components/PageLoading'
import styles from './UserPageTabLoading.module.css'

export default function UserPageTabLoading() {
	return <PageLoading inline aria-label="正在加载内容" className={styles.loading} />
}
